export declare type KeyActionName =
  | BrushToolComponentKeyActionName
  | EraserToolComponentKeyActionName
  | LassoToolComponentKeyActionName
  | ToolListServiceKeyActionName
  | ResetTransparencyComponentKeyActionName
  | UndoRedoComponentKeyActionName
  | ViewChangesToolComponentKeyActionName
  | ResetViewsToolComponentKeyActionName
  | ImageSliderComponentKeyActionName
  | OCCViewerComponentKeyActionName
  | ViewerComponentKeyActionName
  | ContextMenuServiceKeyActionName
  | SaveComponentKeyActionName
  | ColorsMenuComponentKeyActionName;

export type KeyActionNameList = KeyActionName[];

// NOTE: The naming convention is "class name where it calls + KeyActionName"

//BrushToolComponent
export const BrushToolComponentKeyActionNameList = [
  'BrushActivate',
  'ExitBrushMenu',
] as const;
export declare type BrushToolComponentKeyActionName =
  typeof BrushToolComponentKeyActionNameList[number];

// EraserToolComponent
export const EraserToolComponentKeyActionNameList = [
  'EraserActivate',
  'ExitEraserMenu',
] as const;
export declare type EraserToolComponentKeyActionName =
  typeof EraserToolComponentKeyActionNameList[number];

// LassoToolComponent
export const LassoToolComponentKeyActionNameList = [
  'LassoActivate',
  'LassoDefaultMode',
  'LassoSubtructMode',
  'ExitLassoMenu'
] as const;
export declare type LassoToolComponentKeyActionName =
  typeof LassoToolComponentKeyActionNameList[number];

// ToolListService
export const ToolListServiceKeyActionNameList = [
  'IncreaseToolSize',
  'DecreaseToolSize',
] as const;
export declare type ToolListServiceKeyActionName =
  typeof ToolListServiceKeyActionNameList[number];

// ResetTransparencyComponent
export const ResetTransparencyComponentKeyActionNameList = [
  'ResetTransparencyTrigger',
] as const;
export declare type ResetTransparencyComponentKeyActionName =
  typeof ResetTransparencyComponentKeyActionNameList[number];

// UndoRedoComponent
export const UndoRedoComponentKeyActionNameList = [
  'UndoTrigger',
  'RedoTrigger',
] as const;
export declare type UndoRedoComponentKeyActionName =
  typeof UndoRedoComponentKeyActionNameList[number];

// ViewChangesToolComponent
export const ViewChangesToolComponentKeyActionNameList = [
  'ViewChangesActivate',
] as const;
export declare type ViewChangesToolComponentKeyActionName =
  typeof ViewChangesToolComponentKeyActionNameList[number];

// ResetViewsToolComponent
export const ResetViewsToolComponentKeyActionNameList = [
  'ResetViewsTrigger',
] as const;
export declare type ResetViewsToolComponentKeyActionName =
  typeof ResetViewsToolComponentKeyActionNameList[number];

// ImageSliderComponent
export const ImageSliderComponentKeyActionNameList = [
  'PreviousSliceTrigger',
  'NextSliceTrigger',
] as const;
export declare type ImageSliderComponentKeyActionName =
  typeof ImageSliderComponentKeyActionNameList[number];

// OCCViewerComponent
export const OCCViewerComponentKeyActionNameList = ['Exit3DViewTools'] as const;
export declare type OCCViewerComponentKeyActionName =
  typeof OCCViewerComponentKeyActionNameList[number];

// ViewerComponent
export const ViewerComponentKeyActionNameList = [
  'ExitEditImageTools',
  'NumOneViewActivate',
  'OneViewActivate',
  'NumTwoViewsActivate',
  'TwoViewsActivate',
  'NumFourViewActivate',
  'FourViewActivate',
  'SelectNextView',
  'ExitViewTools',
  'ZoomViewActivate',
  'ZoomViewDeactivate',
] as const;
export declare type ViewerComponentKeyActionName =
  typeof ViewerComponentKeyActionNameList[number];

// ContextMenuService
export const ContextMenuServiceKeyActionNameList = [
  'CloseContextMenu',
] as const;
export declare type ContextMenuServiceKeyActionName =
  typeof ContextMenuServiceKeyActionNameList[number];

// SaveComponent
export const SaveComponentKeyActionNameList = ['SaveTrigger'] as const;
export declare type SaveComponentKeyActionName =
  typeof SaveComponentKeyActionNameList[number];

// ColorsMenuComponent
export const ColorsMenuComponentKeyActionNameList = [
  'ShowHideTrigger',
] as const;
export declare type ColorsMenuComponentKeyActionName =
  typeof ColorsMenuComponentKeyActionNameList[number];
